import moment from 'moment';
import 'moment/locale/cs';

import numeral from 'numeral';
import 'numeral/locales/cs';

moment.locale('cs');
numeral.locale('cs');


export function formatDate(date) {
	return moment(date).format('l');
}

export function formatDateTime(dateTime) {
	return moment(dateTime).format('l, LT');
}

function repeat(str, number) {
	let value = '';
	for (let i = 0; i < number; i += 1) {
		value += str;
	}
	return value;
}

export function formatNumber(value, decimals, thousands = true) {
	const sep = thousands ? '0,' : '';
	const format = decimals > 0 ? `${sep}0.${repeat(0, decimals)}` : `${sep}0`;
	return numeral(Number(value)).format(format).replace(/ /g, '\xa0');
}

export function formatCurrency(amount, currency, decimals) {
	const format = decimals > 0 ? `0,0.${repeat(0, decimals)} $` : '0,0 $';
	return numeral(Number(amount)).format(format).replace(/ /g, '\xa0');
}



// WEBPACK FOOTER //
// ./js/utils/format.js